import React from 'react';
import { IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

// CustomPrevArrow Component
const CustomPrevArrow = ({ onClick, isHovering }) => (
	<IconButton
		onClick={onClick}
		sx={{
			position   : 'absolute',
			left       : 4,
			top        : '50%',
			transform  : 'translateY(-50%)',
			zIndex     : 3,
			background : 'rgba(116, 116, 116, 0.7)',
			'&:hover'  : { background: 'rgba(116, 116, 116, 0.7)' },
			transition : 'opacity 0.3s',
			opacity    : isHovering ? 1 : 0,
			padding    : '4px'
		}}
	>
		<KeyboardArrowLeftIcon sx={{ color: '#fff' }} />
	</IconButton>
);

// CustomNextArrow Component
const CustomNextArrow = ({ onClick, isHovering }) => (
	<IconButton
		onClick={onClick}
		sx={{
			position   : 'absolute',
			right      : 4,
			top        : '50%',
			transform  : 'translateY(-50%)',
			zIndex     : 3,
			background : 'rgba(116, 116, 116, 0.7)',
			'&:hover'  : { background: 'rgba(116, 116, 116, 0.7)' },
			transition : 'opacity 0.3s',
			opacity    : isHovering ? 1 : 0,
			padding    : '4px'
		}}
	>
		<KeyboardArrowRightIcon sx={{ color: '#fff' }} />
	</IconButton>
);

export { CustomPrevArrow, CustomNextArrow };
